var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay_inner warning"},[_c('p',{staticClass:"note"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',{staticClass:"buttons"},[_c('a',{staticClass:"btn btn_darkblue",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onClick()}}},[_vm._v("OK")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fce4cd34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PopupAlert.vue
// module id = Ar2y
// module chunks = 0